export default __webpack_public_path__ + "static/media/chat-img.06ea6db3.svg";